export default __webpack_public_path__ + "bda1e6a29f9b649a97a5f453814d448a.svg";